import { MensajesDeCarga, MensajesDeError } from "@/utils/BusesDeEventos.js";
let switchErrors = function (error, excepciones = []) {
  let mensaje = "";
  let excepcion = null;
  if (error && (error.data || error.response || error.status)) {
    if (excepciones.length > 0) {
      let codigoError = error.status || error.response.status;
      excepcion = excepciones.find(excepcionTemp => {
        return "" + excepcionTemp.codigo === "" + codigoError;
      });
      /*if (excepcion) {
        mensaje = excepcion.mensaje;
        codigo = excepcion.codigo;
        if (codigo == 503) {
          tipo = "onAlerta";
          titulo = "Notificación";
        }
      }*/
    }
    if (!excepcion) {
      switch (error.status || error.response.status) {
        case 204:
          mensaje = "Los datos no han sido encontrados o no coinciden con nuestros registros";
          break;
        case 404:
          mensaje =
            "Los datos no han sido encontrados";
          break;
        case 400:
          if (error.data && error.data.errores) {
            let values = Object.keys(error.data.errores).map(function (key) {
              return dictionary[key];
            });
            mensaje = values[0];
          } else if (error.response && error.response.data) {
            if (error.response.data.errors) {
              mensaje = error.response.data.errors[0].defaultMessage;
            } else if (error.response.data.errores) {
              let values = Object.keys(error.response.data.errores).map(
                function (key) {
                  return error.response.data.errores[key][0];
                }
              );
              mensaje = values[0];
            }
          }
          break;
        case 409:
          mensaje = "Error al enviar correo";
          break;
        default:
          mensaje =
            "Los servicios se encuentran temporalmente fuera de servicio, por favor reintentar a la brevedad";
      }
    }
  } else {
    if (error.message) {
      mensaje = error.message;
    } else {
      mensaje =
        "Los servicios se encuentran temporalmente fuera de servicio, por favor reintentar a la brevedad";
    }
  }
  if (mensaje.length > 0) {
    MensajesDeError.$emit("onError", mensaje);
    MensajesDeCarga.$emit("cargado");
  } else {
    console.warn("Error sin mensaje");
  }
};

export default { switchErrors };



// WEBPACK FOOTER //
// ./src/utils/Errores.js